import { useTranslation } from "react-i18next"

function NoData({
    message = null
}) {

    const [t, i18n] = useTranslation(["global"])

    return <div>
        <div className="alert alert-secondary alert-dismissible" key="unique">
            <i className="fa-solid fa-circle-info"></i> {message || t("helper.no_data")}
        </div>
    </div>
}

export default NoData